/**
 * CX Layout (mobile scroll arrows): delegated click for cx layout arrows. Self-contained.
 */
(function () {
  let _reducedMotion = false;
  let _reducedMotionBound = false;
  function ensureReducedMotionCache() {
    if (_reducedMotionBound) return;
    _reducedMotionBound = true;
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    _reducedMotion = !!mql.matches;
    const onChange = (e) => { _reducedMotion = !!e.matches; };
    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', onChange);
    else if (typeof mql.addListener === 'function') mql.addListener(onChange);
  }
  function prefersReducedMotion() { return _reducedMotion; }

  const CX_LAYOUT_ARROW_SELECTOR = '[data-cx-layout-arrow]';
  let CX_LAYOUT_DELEGATED_BOUND = false;

  function bindCxLayoutDelegated() {
    if (CX_LAYOUT_DELEGATED_BOUND) return;
    CX_LAYOUT_DELEGATED_BOUND = true;
    if (window.Shopify?.designMode) return;

    ensureReducedMotionCache();

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const arrow = target?.closest?.(CX_LAYOUT_ARROW_SELECTOR);
      if (!(arrow instanceof HTMLElement)) return;

      const direction = arrow.dataset.direction;
      const targetId = arrow.dataset.target;
      if (!targetId) return;

      const viewport = document.getElementById(targetId);
      if (!(viewport instanceof HTMLElement)) return;

      const firstItem = viewport.querySelector('.cx-layout__inner > *');
      if (!(firstItem instanceof HTMLElement)) return;

      const inner = viewport.querySelector('.cx-layout__inner');
      const gap = inner ? Number.parseInt(getComputedStyle(inner).gap, 10) || 0 : 0;
      const scrollAmount = firstItem.offsetWidth + gap;

      const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
      const atStart = viewport.scrollLeft <= 2;
      const atEnd = viewport.scrollLeft >= maxScrollLeft - 2;

      const behavior = prefersReducedMotion() ? 'auto' : 'smooth';

      if (direction === 'left') {
        if (atStart) {
          viewport.scrollTo({ left: maxScrollLeft, behavior });
          return;
        }

        viewport.scrollBy({ left: -scrollAmount, behavior });
        return;
      }

      if (atEnd) {
        viewport.scrollTo({ left: 0, behavior });
        return;
      }

      viewport.scrollBy({ left: scrollAmount, behavior });
    });
  }

  /** @type {any} */ (window)['CX'] = /** @type {any} */ (window)['CX'] || {};
  /** @type {any} */ (window)['CX'].bindCxLayoutMobileArrows = bindCxLayoutDelegated;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCxLayoutDelegated, { once: true });
  } else {
    setTimeout(bindCxLayoutDelegated, 0);
  }
  document.addEventListener('shopify:section:load', () => bindCxLayoutDelegated());
})();